"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanOptionalAnswerT = exports.NumericStringT = exports.createPhantomTypeSchema = exports.ContactCardInputZ = exports.AddressCardInputZ = exports.StateStringZ = exports.ContactCardT = exports.PostCodeT = exports.AddressCardT = exports.StateStringT = exports.tDatetimeT = exports.tDateT = exports.tBoolT = exports.ModelStrT = exports.ModelTypeT = exports.MaybeT = exports.OriginalSchemaSymbol = void 0;
const tBox = __importStar(require("@sinclair/typebox"));
const compiler_1 = require("@sinclair/typebox/compiler");
const omit_1 = __importDefault(require("lodash/omit"));
const zod_1 = require("zod");
exports.OriginalSchemaSymbol = Symbol('original-schema');
tBox.TypeRegistry.Set('APINullable', (schema, value) => schema[exports.OriginalSchemaSymbol].Check(value));
const MaybeT = (schema) => {
    const compiledSchema = compiler_1.TypeCompiler.Compile(tBox.Type.Union([tBox.Type.Null(), tBox.Type.Undefined(), schema]));
    return (tBox
        .Transform(tBox.Type.Unsafe({
        ...(0, omit_1.default)(schema, Symbol.for('TypeBox.Transform')),
        [tBox.Kind]: 'APINullable',
        nullable: true,
        [exports.OriginalSchemaSymbol]: compiledSchema,
    }))
        .Decode((value) => compiledSchema.Decode(value))
        .Encode((value) => compiledSchema.Encode(value)));
};
exports.MaybeT = MaybeT;
const ModelTypeT = (schema) => tBox.Record(tBox.Number(), schema);
exports.ModelTypeT = ModelTypeT;
const ModelStrT = (schema) => tBox.Record(tBox.String(), schema);
exports.ModelStrT = ModelStrT;
exports.tBoolT = tBox.Type.Union([tBox.Type.Literal(0), tBox.Type.Literal(1)]);
exports.tDateT = tBox.String({ format: 'date' });
exports.tDatetimeT = tBox.String({ format: 'date-time' });
exports.StateStringT = tBox.Type.Union([
    tBox.Type.Literal('VIC'),
    tBox.Type.Literal('NSW'),
    tBox.Type.Literal('ACT'),
    tBox.Type.Literal('TAS'),
    tBox.Type.Literal('SA'),
    tBox.Type.Literal('WA'),
    tBox.Type.Literal('NT'),
    tBox.Type.Literal('QLD'),
]);
exports.AddressCardT = tBox.Object({
    ID: tBox.Number(),
    Address: (0, exports.MaybeT)(tBox.String()),
    Locale: (0, exports.MaybeT)(tBox.String()),
    State: (0, exports.MaybeT)(exports.StateStringT),
    PostCode: (0, exports.MaybeT)(tBox.String()),
    Complete: tBox.Boolean(),
    Note: (0, exports.MaybeT)(tBox.String()),
});
exports.PostCodeT = tBox.Object({
    ID: tBox.Number(),
    PostCode: tBox.String(),
    Locality: tBox.String(),
    State: tBox.String(),
    DeliveryArea: exports.tBoolT,
    IsValid: exports.tBoolT,
});
exports.ContactCardT = tBox.Object({
    ID: tBox.Number(),
    Email: (0, exports.MaybeT)(tBox.String()),
    Phone: (0, exports.MaybeT)(tBox.String()),
    Mobile: (0, exports.MaybeT)(tBox.String()),
    Fax: (0, exports.MaybeT)(tBox.String()),
    Website: (0, exports.MaybeT)(tBox.String()),
});
exports.StateStringZ = zod_1.z.enum(['VIC', 'NSW', 'ACT', 'TAS', 'SA', 'WA', 'NT', 'QLD']);
exports.AddressCardInputZ = zod_1.z.object({
    Address: zod_1.z.string().optional(),
    Locale: zod_1.z.string().optional(),
    State: exports.StateStringZ.optional(),
    PostCode: zod_1.z.string().optional(),
    Note: zod_1.z.string().optional(),
});
exports.ContactCardInputZ = zod_1.z.object({
    Email: zod_1.z.string().optional(),
    Phone: zod_1.z.string().optional(),
    Mobile: zod_1.z.string().optional(),
    Fax: zod_1.z.string().optional(),
    Website: zod_1.z.string().optional(),
});
const createPhantomTypeSchema = (schema) => ({
    schema,
    _type: null,
});
exports.createPhantomTypeSchema = createPhantomTypeSchema;
const NumericStringT = () => tBox
    .Transform(tBox.Unsafe(tBox.Union([tBox.String(), tBox.Number()])))
    .Decode(value => `${value}`)
    .Encode(value => `${value}`);
exports.NumericStringT = NumericStringT;
exports.BooleanOptionalAnswerT = (0, exports.MaybeT)(tBox.Union([tBox.Literal(1), tBox.Literal(2), tBox.Literal(3)]));
//# sourceMappingURL=meta-types.js.map